import { MarketTemplate } from "../../data";
import { isMarketType } from "../../helpers";
export const prepareSelections = (market, isTeamSwap) => {
    if (isMarketType(market.marketType.id, "ML") || isMarketType(market.marketType.id, "HC")) {
        let orderedSelections = isTeamSwap
            ? market.selections.slice().reverse()
            : market.selections.slice();
        if (market.template === MarketTemplate.ThreeBox) {
            let drawSelection = orderedSelections.splice(1, 1)[0];
            orderedSelections.push(drawSelection);
        }
        return orderedSelections;
    }
    return market.selections;
};
//# sourceMappingURL=prepareSelections.js.map